import Vue, { ref } from 'vue';
import ToastComponent from './index.vue';

const ToastConstractor = Vue.extend(ToastComponent);

export const currentInstance = ref();

export function MToast(options = {}) {
  if (process.env.SERVER) return;
  if (currentInstance.value && currentInstance.value.visible) {
    Object.assign(currentInstance.value.state, options);
    currentInstance.value.start();
    return currentInstance;
  }
  const ins = new ToastConstractor();
  Object.assign(ins.state, options);
  ins.$mount();
  document.body.appendChild(ins.$el);
  ins.visible = true;
  currentInstance.value = ins;
  return ins;
}
